enum FieldSystemType {
    string = 'string',
    number = 'number',
    linked = 'linkedField',
    pointer = 'pointer',
    uid = 'uid',
    rollup = 'rollup'
}

export default FieldSystemType;